import React from 'react'
import BackButton from './BackButton'
import '../../../styles/containers/SavingsCalculator/savingsCalculator.scss';
import '../../../styles/containers/SavingsCalculator/components/navigation-section.scss';
function NavigationSection({path, search,isWebview,reload}) {
    return (
        <div className='d-flex justify-content-between __navigation-container __horizontal-center'>
            <div className='d-flex align-items-center'>
                <BackButton path={path} search={search} reload={reload}/>
            </div>
        </div>
    )
}

export default NavigationSection
